import React, { lazy } from 'react';
import ProcessManage from './Process/ProcessManage';

const Organization = lazy(() => import('./Organization/Organization'));
const Positions = lazy(() => import('./Position/Positions'));
const EmployeeArchive = lazy(() => import('./Employee/EmployeeArchive'));
const EmployeeArchiveDetail = lazy(() => import('./Employee/EmployeeArchiveDetail'));
const Statistics = lazy(() => import('./Statistics/Statistics'));
const OnboardingManage = lazy(() => import('./Onboarding/OnboardingManage'));
const OnboardingEmployeeForm = lazy(() => import('./Onboarding/OnboardingEmployeeForm'));
const RegularizationManage = lazy(() => import('./Regularization/RegularizationManage'));
const BankBranches = lazy(() => import('./BankBranch/BankBranches'));

export const hrPageRoutes = [
  { path: '/hr/organization', component: Organization },
  { path: '/hr/position-title', component: Positions },
  { path: '/hr/onboarding/drafts/:draftId', component: OnboardingEmployeeForm },
  { path: '/hr/onboarding/new', component: OnboardingEmployeeForm },
  { path: '/hr/onboarding/:employeeNo/edit', component: OnboardingEmployeeForm },
  { path: '/hr/onboarding', component: OnboardingManage },
  { path: '/hr/employee-archive/:employeeNo', component: EmployeeArchiveDetail },
  { path: '/hr/employee-archive', component: EmployeeArchive },
  { path: '/hr/regularization', component: RegularizationManage },
  { path: '/hr/transfer', component: ProcessManage },
  { path: '/hr/resignation', component: ProcessManage },
  { path: '/hr/statistics', component: Statistics },
  // 兼容旧地址：菜单已搬到财务管理（/expense/bank-branches），保留旧路径可访问
  { path: '/hr/bank-branches', component: BankBranches }
];

export default hrPageRoutes;
